import Header from "./Header";
import Footer from "./footer";
// import { Carousel } from 'react-responsive-carousel';
import Slider from "react-slick";
// import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Post,LoginURL,forgotPassword,loginWithOtp, homeURL, image_url, AddToCartURL } from '../utils/api';
import { useNavigate,Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { wrapComponent } from 'react-snackbar-alert';
import { Grid } from "@mui/material";

var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
};
var settings1 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 7,
    slidesToScroll: 3,
};

var settings3 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 3,
};

const Ingredients = ({createSnackbar}) => {
    const navigate = useNavigate();
    const [state,setState] = useState({
        featured_pro:[],
        ingredients:[]
    });

    const stateHandler = (key, value) => {
        state[key] = value;
        setState({ ...state });
    };

    useEffect(()=>{
        fetchHomeItems();
    },[]);

    
    const fetchHomeItems = () =>{
        global.Loader(true)
        let config = {
            url:homeURL
        }
        Post(config).then((res)=>{
            global.Loader(false)
            if(res.status == true) {
                setState({
                    ingredients:res?.ingredients,
                })
            }
        }).catch((err)=>{
            global.Loader(false)
            console.log(err);
        })
    }

    return (
      <div>
      <Header />
      <div className="large ingredents-page">
        <div className="container">
            <div className="shoplink">
                <ul>
                    <li onClick={()=>{
                        navigate('/home')
                    }}>Home</li> <i className="fa-solid fa-chevron-right" style={{'marginRight':'5px'}}></i>
                    <li onClick={()=>{
                        navigate('/ingredents')
                    }}>Ingredients</li> <i className="fa-solid fa-chevron-right" style={{'marginRight':'5px'}}></i>
                </ul>
            </div>
            <div className="enriched">
                <div style={{'marginBottom':'100px'}}>
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                    {state?.ingredients?.map((v,i) => (
                        <Grid item xs={3}>
                            <div key={`indgrents_${i}`} className="item1">
                                <div className="">
                                    <div className="ORANGE">
                                        <div style={{
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            display: 'flex',
                                            marginTop: '-10%',
                                        }}>
                                            <img src={`${image_url}${v?.image}`} alt="" style={{height:'140px',width:'140px',marginTop: '14%'}}/>
                                        </div>
                                        <h3>{v?.title}</h3>
                                        <p>{v.description}</p>
                                        <a href={`Ingredient/${i}`} class="details-btn">VIEW PRODUCTS</a>
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    ))}
                </Grid>
                </div>
            <div className="overlay"></div>
            </div>
        </div>
        <div className="back">
                <ul className="pager">
                    {/* <li><a href="#" className="back1"><i className="fa-solid fa-angle-left"></i> Back</a></li>
                    <li><a href="#" className="back2">1</a></li>
                    <li><a href="#" className="back3">2</a></li>
                    <li><a href="#" className="back4">3</a></li>
                    <li><a href="#" className="next">Next <i className="fa-solid fa-angle-right"></i></a></li> */}
                </ul>
            </div>
    </div>
    <div className="speci">
        <div className="icon1">
           <div className="facebook"> <i className="fa-brands fa-facebook-f"></i></div>
           <div className="twitter"><i className="fa-brands fa-twitter"></i></div>
           <div className="instagram"><i className="fa-brands fa-instagram"></i></div>
           <div className="pinterest"><i className="fa-brands fa-pinterest-p"></i></div>
           <div className="youtube"><i className="fa-brands fa-youtube"></i></div>
           <div className="linkedin"><i className="fa-brands fa-linkedin-in"></i></div>
        </div>
    </div>
      <Footer />
    </div>
    );
  };
  
export default wrapComponent(Ingredients);